export const EVENTS_CHANNEL = 'credit_form:events';

// CREDIT WIDGET
export const CREDIT_CALCULATOR_CHANNEL = 'credit_calclulator:events';
export const CREDIT_CALCULATOR_PROGRAM_SELECTED_EVENT = 'program_selected';
